import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const ApplicationNavbar = () => {
  // integration of react-router-dom hooks here
  const { pathname } = useLocation();

  // rendering application navbar component here
  return (
    <motion.nav
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: {
          ease: 'easeInOut',
          y: { duration: 0.5 },
        },
      }}
      className='w-[95%] md:w-[90%] lg:w-4/5 max-w-[1500px] mx-auto grid grid-cols-2 md:flex items-center gap-2 bg-white shadow-academia-sm p-2 rounded-xl'
    >
      <Link
        to={'/application/update'}
        className={`font-semibold text-center md:text-left rounded-lg hover:bg-base-light-blue/30 px-4 py-2 active:scale-95 duration-300 ${
          pathname.includes('update')
            ? 'bg-legal-dark-blue text-legal-brown hover:text-legal-dark-blue'
            : 'text-legal-dark-blue bg-transparent'
        }`}
      >
        Application Update
      </Link>

      <Link
        to={'/application/tracking'}
        className={`font-semibold text-center md:text-left rounded-lg hover:bg-base-light-blue/30 px-4 py-2 duration-300 active:scale-95 ${
          pathname.includes('tracking')
            ? 'bg-legal-dark-blue text-legal-brown hover:text-legal-dark-blue'
            : 'text-legal-dark-blue bg-transparent'
        }`}
      >
        Application Tracking
      </Link>
    </motion.nav>
  );
};

export default ApplicationNavbar;
